module.exports = __webpack_public_path__ + "static/media/track.dd955e25.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/track.mp3
// module id = 369
// module chunks = 0